"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/esnext.map.delete-all");

require("core-js/modules/esnext.map.every");

require("core-js/modules/esnext.map.filter");

require("core-js/modules/esnext.map.find");

require("core-js/modules/esnext.map.find-key");

require("core-js/modules/esnext.map.includes");

require("core-js/modules/esnext.map.key-of");

require("core-js/modules/esnext.map.map-keys");

require("core-js/modules/esnext.map.map-values");

require("core-js/modules/esnext.map.merge");

require("core-js/modules/esnext.map.reduce");

require("core-js/modules/esnext.map.some");

require("core-js/modules/esnext.map.update");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductsServiceCallFindOneByIdOrSkuCached;

var _react = _interopRequireDefault(require("react"));

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

// import useResolveServiceActionName from '@sprinx/react-api-client/useResolveServiceActionName';
// import useProductsContext from '../useProductsContext';
var ttlOffset = 10 * 60 * 1000;
var cache = new Map();

function useProductsServiceCallFindOneByIdOrSkuCached(options) {
  // const { clientCode, serviceNames } = useProductsContext();
  var call = (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, idOrSku) {
    return client.call('v1.products.findOneByIdOrSku', {
      idOrSku: idOrSku
    }, {
      method: 'get',
      mockAction: 'findOneByIdOrSku'
    });
  });
  return _react.default.useCallback(function (idOrSku) {
    var rec = cache.get(idOrSku);

    if (rec && rec.ttl >= Date.now()) {
      return rec.promise;
    }

    var promise = call(idOrSku);
    cache.set(idOrSku, {
      ttl: Date.now() + ttlOffset,
      promise: promise
    });
    return promise;
  }, [call]);
}